import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Image, Tooltip, Space, Input } from "antd";
import { FaEdit, FaTrash } from "react-icons/fa";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { SearchOutlined } from '@ant-design/icons';
import PermissionGuard from "../Guards/PermissionGuard";
import { PERMISSIONS } from "../../constants/permissions";

const PackagesTable = () => {
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [searchFilters, setSearchFilters] = useState({
            name: ""
        });
    const navigate = useNavigate();

    const fetchPackages = async (page = 1, pageSize = 10) => {
        try {
            setLoading(true);
            const response = await axios.get(`${config.apiBaseUrl}/api/package/GetList`, {
                params: { page, pageSize },
                headers: { HeaderKey: config.HeaderKey },
                withCredentials: true,
            });
            setPackages(response.data.data.packages);
            
            setPagination({
                current: page,
                pageSize: pageSize,
                total: response.data.data.count,
            });
        } catch (error) {
            toast.error("خطا در دریافت لیست بسته‌ها");
            if (error.response?.status === 401) navigate("/");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPackages();
    }, []);

    const handleEdit = (pkg) => {
        navigate("/dashboard/package/form", { state: { package: pkg } });
    };

    const handleDelete = (id) => {
        toast.warn(
            <div className="text-right font-custom">
                <p>آیا از حذف این پکیج مطمئن هستید؟</p>
                <div className="flex justify-end gap-2 mt-2">
                    <button
                        className="bg-red-500 hover:bg-red-700 text-white px-3 py-1 rounded"
                        onClick={() => confirmDelete(id)}
                    >
                        حذف
                    </button>
                    <button
                        className="bg-gray-500 hover:bg-gray-700 text-white px-3 py-1 rounded"
                        onClick={() => toast.dismiss()}
                    >
                        انصراف
                    </button>
                </div>
            </div>,
            { autoClose: false, icon: false }
        );
    };
    const confirmDelete = async (id) => {
        try {
            toast.dismiss();

            const response = await axios.post(
                `${config.apiBaseUrl}/api/package/DeletePackage?id=${id}`,{},
                {
                    headers: {
                        "Content-Type": "application/json",
                        "HeaderKey": config.HeaderKey
                    },
                    withCredentials: true,
                }
            );
            if (response.status === 200) {
                toast.success(<p dir="rtl" className="font-custom">پکیج با موفقیت حذف شد</p>, { autoClose: 3000 });
                fetchPackages(pagination.current, pagination.pageSize);
            } else {
                toast.error(<p dir="rtl" className="font-custom">خطا در حذف پکیج</p>, { autoClose: 3000 });
            }
        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">خطا در ارتباط با سرور</p>, { autoClose: 3000 });
        }
    };
    const fetchPackagesWithFilters = async () => {

        try {
            setLoading(true);

            let dynamicFilter = "";

            if (searchFilters.name) {
                dynamicFilter += `Title=*${searchFilters.name}/i`;
            }
            console.log({dynamicFilter})
            
            const response = await axios.get(
                `${config.apiBaseUrl}/api/package/GetList`,
                {
                    params: {
                        page: 1,
                        pageSize: 10,
                        orderBy: "CreateDatetime desc",
                        filter: dynamicFilter,  // Pass the dynamic filter
                    },
                    headers: {
                        "HeaderKey": config.HeaderKey
                    },
                    withCredentials: true,
                }
            );
            setPackages(response.data.data.packages);
        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">جستجو با خطا مواجه شد</p>);
            if (error.response && error.response.status === 401) {
                navigate("/");
            }
        } finally {
            setLoading(false);
        }
    };
const handleSearchChange = (e, columnName) => {


        let value = e.target.value;

        const newFilters = {
            ...searchFilters,
            [columnName]: value
        };


        setSearchFilters(newFilters);



        const filteredData = packages.filter(pckg => {
            return (
                (!newFilters.name || pckg.title.toLowerCase().includes(newFilters.name.toLowerCase())) 
            );
        });

    };
    const columns = [
        {
            title: "عملیات",
            key: "actions",
            fixed: "left",
            className:"font-custom",
            align: "center",
            width: 100,
            render: (row) => (
                <div className="flex gap-2 justify-center">
                    <PermissionGuard permission={PERMISSIONS.PACKAGES_EDIT}>
                        <Tooltip title="ویرایش">
                            <Button
                                type="link"
                                icon={<FaEdit size={18} />}
                                onClick={() => handleEdit(row)}
                            />
                        </Tooltip>
                    </PermissionGuard>
                    <PermissionGuard permission={PERMISSIONS.PACKAGES_DELETE}>
                        <Tooltip title="حذف">
                            <Button
                                type="link"
                                danger
                                icon={<FaTrash size={18} />}
                                onClick={() => handleDelete(row.id)}
                            />
                        </Tooltip>
                    </PermissionGuard>
                </div>
            ),
        },
        
        
        {
            title: "تعداد دوره‌ها",
            dataIndex: "courseCount",
            key: "courseCount",
            align: "center",
            className: "font-custom",
        },
        {
            title: "تاریخ آخرین ویرایش",
            dataIndex: "updateDatetime",
            key: "updateDatetime",
            className:"font-custom",
            align: "center",
            render: (date) => new Date(date).toLocaleDateString("fa-IR"),
        },
        {
            title: "تاریخ ایجاد",
            dataIndex: "createDatetime",
            className:"font-custom",
            key: "createDatetime",
            align: "center",
            render: (date) => new Date(date).toLocaleDateString("fa-IR"),
        },
        {
            title: "عنوان",
            dataIndex: "title",
            key: "title",
            align: "center",
            className: "font-custom",
            filterDropdown: () => (

                <div style={{ padding: 8 }}>
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            className="font-custom"
                            placeholder="جستجوی عنوان"
                            allowClear
                            onClear={() => {
                                // Reset the search filter and re-fetch data
                                setSearchFilters((prevState) => ({
                                    ...prevState,
                                    name: "",
                                }));
                            }}
                            value={searchFilters.name}
                            onChange={(e) => {
                                handleSearchChange(e, "name");
                            }}
                            onPressEnter={() => {
                                fetchPackagesWithFilters();
                            }}
                        />
                        <Button type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // Server-side search when button is clicked
                                fetchPackagesWithFilters();
                            }}
                        />
                    </Space.Compact>
                </div>
            ),
        },
        {
            title: "تصویر",
            dataIndex: "pictureUrl",
            key: "pictureUrl",
            className:"font-custom",
            align: "center",
            width: 80,
            render: (url) => (
                <Image
                    src={`${config.apiBaseUrl}${url}`}
                    alt="package"
                    width={50}
                    height={50}
                    className="object-cover rounded"
                />
            ),
        },
    ];

    return (
        <div className="font-custom rtl text-right p-5">
            <h1 className="text-center text-xl mb-5">لیست پکیج‌ها</h1>
            <PermissionGuard permission={PERMISSIONS.PACKAGES_CREATE}>
                <button
                    className="bg-green-700 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-full shadow-md transition duration-300 mb-5"
                    onClick={() => navigate("/dashboard/package/form")}
                >
                    + جدید
                </button>
            </PermissionGuard>
            <Table
                columns={columns}
                dataSource={packages}
                loading={loading}
                rowKey={(record) => record.id}
                scroll={{ x: 800 }}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    onChange: (page, pageSize) => {
                        setPagination({ current: page, pageSize });
                        fetchPackages(page, pageSize);
                    },
                }}
                bordered
            />

            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                transition={Bounce}
            />
        </div>
    );
};

export default PackagesTable;
